import useSWR from 'swr';

import { findLocaleFromUrlAndCookie } from '@zooplus/commons-lang';

import { MembershipOfferBenefitType, MembershipOfferPrice } from './useMembershipOffer';

export interface MembershipPrices {
  price: MembershipOfferPrice;
  referencePrice?: MembershipOfferPrice;
  secondaryCurrencyPrice?: MembershipOfferPrice;
}

export interface MembershipInfo {
  membershipPrice?: MembershipPrices;
  benefits: Array<MembershipOfferBenefitType>;
  articleId?: number;
}

export interface MembershipsComparison {
  customerLoyaltyLevelType?: string;
  basicLoyaltyMembershipInfo: MembershipInfo;
  premiumLoyaltyMembershipInfo: MembershipInfo;
}

export function useMembershipsComparison() {
  return useSWR(
    '/semiprotected/api/loyalty-management/memberships/comparison',
    async (...args): Promise<MembershipsComparison> => {
      const response = await fetch(...args, {
        headers: { locale: findLocaleFromUrlAndCookie() || 'en-GB' },
      });

      return await response.json();
    },
    {
      errorRetryInterval: 1000,
      errorRetryCount: 3,
    },
  );
}

export function useMembershipBenefit(membershipInfo: MembershipInfo) {
  function getMembershipBenefitType<T extends MembershipOfferBenefitType['type']>(
    benefitType: T,
  ): Extract<MembershipOfferBenefitType, { type: T }> | undefined {
    return membershipInfo.benefits.find(
      (benefit): benefit is Extract<MembershipOfferBenefitType, { type: T }> =>
        benefit.type === benefitType,
    );
  }

  return { getMembershipBenefitType };
}
